import { jsPDF } from "jspdf";
import "jspdf-autotable";
import {
  getFieldLabel,
  getFieldValue,
  needsMessagesForFields,
} from "./conversationExportFields";
import { fetchMessagesForConversations } from "./fetchAllConversationMessages";

function escapeCsvCell(value) {
  const str = value == null ? "" : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function buildExportRows({ rows, selectedKeys, context }) {
  const headers = selectedKeys.map(getFieldLabel);
  const data = rows.map((row) => selectedKeys.map((key) => getFieldValue(key, row, context)));
  return { headers, data };
}

function downloadCsv(headers, data, fileName) {
  const lines = [
    headers.map(escapeCsvCell).join(","),
    ...data.map((row) => row.map(escapeCsvCell).join(",")),
  ];
  const blob = new Blob(["\uFEFF" + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

function exportPdf({ headers, data, title, fileName }) {
  const doc = new jsPDF({ orientation: headers.length > 6 ? "landscape" : "portrait" });
  doc.text(title, 14, 12);
  doc.autoTable({
    head: [headers],
    body: data,
    startY: 18,
    styles: { fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    headStyles: { fillColor: [25, 118, 210] },
    columnStyles: Object.fromEntries(
      headers.map((_, index) => [index, { cellWidth: "wrap" }])
    ),
  });
  doc.save(`${fileName}.pdf`);
}

/**
 * Exportação avançada com campos selecionados e dados opcionais de mensagens.
 */
export async function runAdvancedConversationExport({
  rows = [],
  selectedIds = [],
  selectedKeys = [],
  format = "csv",
  title = "Resultados da Busca",
  fileName = "resultados_busca",
  exportContext = {},
  onProgress,
}) {
  const idSet = new Set(selectedIds.map((id) => String(id)));
  const selectedRows = rows.filter((row) => idSet.has(String(row.id)));
  if (!selectedRows.length || !selectedKeys.length) {
    return { ok: false, reason: "empty" };
  }

  let messagesByLeadId = {};
  if (needsMessagesForFields(selectedKeys)) {
    onProgress?.({ phase: "messages", completed: 0, total: selectedRows.length });
    messagesByLeadId = await fetchMessagesForConversations(
      selectedRows.map((r) => r.id),
      {
        onProgress: (completed, total) => onProgress?.({ phase: "messages", completed, total }),
      }
    );
  }

  const context = { ...exportContext, messagesByLeadId };
  const { headers, data } = buildExportRows({
    rows: selectedRows,
    selectedKeys,
    context,
  });

  if (format === "pdf") {
    exportPdf({ headers, data, title, fileName });
  } else {
    downloadCsv(headers, data, fileName);
  }

  return { ok: true, rowCount: selectedRows.length };
}
